import { render, staticRenderFns } from "./View15.vue?vue&type=template&id=4f8120c2"
import script from "./View15.vue?vue&type=script&lang=js"
export * from "./View15.vue?vue&type=script&lang=js"
import style0 from "./View15.vue?vue&type=style&index=0&id=4f8120c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports